import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { StageService } from '../../formation/stage-modal/stage-onglet/services/stage-modal.service';
import { BreadcrumbModel, CRUD, GQueovalDik, QResult, QueovalParam } from '../../models';
import { EffectifModel } from '../../models/effectif/effectif.model';
import { GenericEffectif } from '../../models/effectif/genericEffectif.model';
import { ModeEffectif, RenderType, SelectionMode } from '../../models/effectif/option.model';
import { BreadcrumbService, CoreService, HttpService } from '../../services';
import { EffectifsService } from '../effectifs.service';

@Component({
  selector: 'effectifs-render',
  templateUrl: './effectifs-render.component.html',  
  styleUrls: ['./effectifs-render.component.css']
})
export class EffectifsRenderComponent implements OnInit {

  @Input('Mode') set SetMode(mode: CRUD) {
    this.Mode = mode;
  }

  @Input('List') set SetListToDisplay(list: Array<GenericEffectif>) {

    this.ListToDisplay = list;
  }

  // on utilise l'input pour faire un output qui contient l'effectif séléctionné ( suppression ou ajout ) du manager vers le wrapper
  @Input('EffectifSelected') set SetEffectifSelected(effectif: GenericEffectif) {
    this.EmitEffectifs(effectif);
  }

  @Input('Template') set SetTemplate(template: TemplateRef<any>) {
    this.template = template;
  }

  @Output() EventEffectifSelect: EventEmitter<Array<GenericEffectif>> = new EventEmitter<Array<GenericEffectif>>();

  @Output('EventEffectif') EventEffectif: EventEmitter<GenericEffectif> = new EventEmitter<GenericEffectif>();

  @Input() displayList: boolean = true;

  public RenderType = RenderType;

  public SelectionMode = SelectionMode;

  public ModeEffectif = ModeEffectif;

  public CRUD = CRUD;

  public Mode: CRUD;

  public ListIdToEmit: Array<string> = new Array<string>();

  public ListToDisplay: Array<GenericEffectif> = new Array<GenericEffectif>();

  public effectifsToDelete: Array<ClientsToDelete> = new Array<ClientsToDelete>();

  public template: TemplateRef<any>;

  public displayApprenantInfo: boolean = false;
  public displayClientInfo: boolean = false;

  public InfoLink: string;



  @ViewChild('ModalConfirmDelete') modalConfirmDelete: ElementRef;

  constructor(
    public service: EffectifsService,
    public Stageservice: StageService,
    private modalService: NgbModal,
    protected http: HttpService,
    protected indParam: CoreService,
    private breadCrumb: BreadcrumbService,
  ) { }

  ngOnInit(): void {

    this.Stageservice.isModeCursus.subscribe((result: boolean) => {
      this.service.EffectifModel.Cycles = result;
      //this.service.loadData();
    })

  }

  public EmitEffectifs(effectif: GenericEffectif) {
    this.EventEffectif.emit(effectif);
  }

  public OnSelectChange(effectif: GenericEffectif): void {
    if (this.service.Options.SelectionMode == SelectionMode.MULTIPLE) {
      effectif.IsSelected = !effectif.IsSelected;
    } else {
      this.service.EffectifModel.DataListSelect.forEach(eff => {
        eff.IsSelected = false;
      })
      effectif.IsSelected = true;
    }
    this.EmitEffectifs(effectif);
  }


  public RemoveEffectifFromSelect(effectif: GenericEffectif) {
    this.service.EffectifModel.Mode = "DELETELIEN";
    this.service.EffectifModel.IdEffectifToMove = effectif.Id;

    this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/effectifs/postData`, this.service.EffectifModel).subscribe((data: EffectifModel) => {

      if (!data.HasError) {
        if (this.service.Options.RenderType != RenderType.PMSTAGE) {

          this.service.EffectifModel.DataListAll.push(effectif);
          this.service.EffectifModel.DataListAll.sort((a, b) => {
            if (a.Text > b.Text) {
              return 1;
            }
            if (a.Text < b.Text) {
              return -1;
            }
            return 0;
          });

          this.service.EffectifModel.DataListAll = [...this.service.EffectifModel.DataListAll];
        } else {
          this.EmitEffectifs(effectif);
        }

        this.service.EffectifModel.DataListSelect = this.service.EffectifModel.DataListSelect.filter(eff => eff.Id != effectif.Id).map(eff => { return eff });



        this.Stageservice.SetRefresh();

      }
    });
  }

  public AddEffectifToSelect(effectif: GenericEffectif) {
    this.service.EffectifModel.Mode = "INSERTLIEN";
    this.service.EffectifModel.IdEffectifToMove = effectif.Id;
    this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/effectifs/postData`, this.service.EffectifModel).subscribe((data: EffectifModel) => {

      if (!data.HasError) {
        //this.service.loadData();
        this.service.EffectifModel.DataListSelect.push(effectif);
        this.service.EffectifModel.DataListSelect.sort((a, b) => {
          if (a.Text > b.Text) {
            return 1;
          }
          if (a.Text < b.Text) {
            return -1;
          }
          return 0;
        });

        this.service.EffectifModel.DataListAll = this.service.EffectifModel.DataListAll.filter(eff => eff.Id != effectif.Id).map(eff => { return eff });

        this.service.EffectifModel.DataListSelect = [...this.service.EffectifModel.DataListSelect];

       // this.ForceRefreshEffectif.emit()

       // this.service.loadData();
        this.Stageservice.SetRefresh();
      }
    });
  }

  public RemoveElements(value: string[]): void {
    const model: GQueovalDik<string, Array<string>> = new GQueovalDik<string, Array<string>>();
    model.Key = this.service.Options.SelectedData.IdOrigin;
    model.Value = value;
    this.http.postHttp<QResult<Array<ClientsToDelete>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Display/IS_CLIENT_DELETABLE`, model).subscribe((result: QResult<Array<ClientsToDelete>>) => {

      if (result.Value) {
        this.effectifsToDelete = result.Value;
        this.displayApprenantInfo = this.effectifsToDelete.filter(client => client.Contacts.filter(contact => contact.CheckBoxDelete).length > 0).length > 0;
        this.displayClientInfo = this.effectifsToDelete.filter(client => client.Conventions.filter(conv => !conv.Deletable).length > 0).length > 0;
      }
      this.OpenModal(this.modalConfirmDelete);
    });
  }

  public DeleteEffectifs(modal: any): void {
    const model: GQueovalDik<string, Array<ClientsToDelete>> = new GQueovalDik<string, Array<ClientsToDelete>>();
    model.Key = this.service.Options.SelectedData.IdOrigin;
    model.Value = this.effectifsToDelete;
    this.http.postHttp<QResult<Array<ClientsToDelete>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Display/REMOVE_CLIENT_FROM_STAGE`, model).subscribe((result: QResult<Array<ClientsToDelete>>) => {

      this.service.loadData();
      this.Stageservice.SetRefresh();
      //this.service.GetListFilter();
      modal.dismiss();
    });
  }


  public OnConventionChange(convention: ConventionsToDelete, client: ClientsToDelete, value: boolean): void {
    convention.IsSelected = value;
    client.Deletable = client.Conventions.filter(conv => !conv.Deletable && conv.IsSelected).length == 0
  }

  public SaveLinkInfos() {
    this.service.EffectifModel.Mode = "INSERTCOMMENTLIEN";
    this.service.EffectifModel.DataListSelect.find(person => person.Id == this.service.EffectifModel.IdEffectifToComment)!.LinkInfos = this.InfoLink;
    this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/effectifs/postData`, this.service.EffectifModel).subscribe((data: EffectifModel) => {
      if (!data.HasError) {
        this.service.loadData();
        this.modalService.dismissAll();
      }
    });
  }

  public OnSaveBo(event: Event, modal: any) {
    this.service.loadData();
    this.Stageservice.SetRefresh();
    modal.dismiss();
  }

  //#region Gestion Modal

  // Ouverture de la page de gestion de l'action commerciale
  public OpenActionCo(effectif: GenericEffectif) {
    //#region redirection vers l'action commerciale
    const param: QueovalParam = new QueovalParam();
    param.params.push({ key: 'params', value: `idActionCo=${effectif.IdActionCo}` });
    this.modalService.dismissAll();
    this.breadCrumb.call(new BreadcrumbModel('add', 'view/action-commerciale/carte', param, 'Action commerciale', false));
    //#endregion
  }

  // Ouverture de la modale pour le commentaire sur le lien Inf01LIF
  public OpenModalComment(Modal: any, effectif: GenericEffectif) {
    this.service.EffectifModel.IdEffectifToComment = effectif.Id;
    this.InfoLink = effectif.LinkInfos;
    this.modalService.open(Modal, { centered: true, size: 'q-xl', windowClass: 'qmodalover' });
  }

  // Ouverture de la modal
  public OpenModal(Modal: any) {
    this.modalService.open(Modal, { centered: true, size: 'q-xl', windowClass: 'qmodalover' });
  }

  // Ouverture de la modal pour consulter/update le bo de l'effectif
  public OpenBoEffectif(Modal: any, identEffectif: string) {
    this.service.Model.IdDonneeFils = identEffectif;
    this.modalService.open(Modal, { centered: true, size: 'q-xxl', windowClass: 'qmodalover' });
  }

  //#endregion Gestion Modal
}

// A REVOIR TRES VITE

export class ClientsToDelete extends GenericEffectif {
  public Deletable: boolean;
  public Contacts: Array<ContactsToDelete>;
  public Conventions: Array<ConventionsToDelete>;
}

export class ContactsToDelete extends GenericEffectif {
  public Deletable: boolean;
  public CheckBoxDelete: boolean;
}
export class ConventionsToDelete {
  public Id: string;
  public Titre: string;
  public Deletable: boolean;
  public CheckBoxDelete: boolean;
  public IsSelected: boolean;
}

